import DisplayOnDesktop from './DisplayOnDesktop';

export default DisplayOnDesktop;
